// Auto-generated from API controllers: GET endpoints that require userid as a query param.
export const GET_ENDPOINTS_REQUIRING_USERID = new Set([
  "account/getuseravatar",
  "account/getuserfollowers",
  "account/getusersfollowing",
  "account/isonline",
  "account/userlist",
  "accountprofile/usergroups",
  "accountprofile/userinfo",
  "accountprofile/userprofileimage",
  "blog/getblog",
  "blog/getblogtemplates",
  "blog/getuserblogchannels",
  "blog/getuserblogs",
  "business/getbusinessesbyadminuser",
  "business/getclientuserdata",
  "business/getuseraffiliations",
  "business/getuserbusinesses",
  "business/isadminuser",
  "calendar/getdaydetails",
  "calendar/getdays",
  "calendar/getfamilycalendaritems",
  "calendar/getmessageuser",
  "calendar/getusercalendaritems",
  "comments/getmycomments",
  "document/downloadpdf",
  "document/getalldocuments",
  "document/getdocument",
  "document/getdocumentinfo",
  "document/getdocuments",
  "document/getfolders",
  "document/getuserfolders",
  "entity/getuserentitylist",
  "event/getattendees",
  "event/getevent",
  "event/geteventsiattended",
  "event/geteventsimattending",
  "event/getmyevents",
  "event/getmypastevents",
  "event/search",
  "family/getallmyfamilies",
  "family/getallmyownedfamilies",
  "family/getmyprimaryfamily",
  "link/getalllinks",
  "link/getfolders",
  "link/getlinks",
  "link/getuserfolders",
  "list/getalllists",
  "list/getlists",
  "mentions/getmentionsbyuser",
  "messenger/getorcreategroupthread",
  "messenger/getorcreateuserthread",
  "music/getalbums",
  "music/getartists",
  "music/getplaylists",
  "music/getsongs",
  "note/getallusernotebooks",
  "note/getallusernotes",
  "note/getdailynote",
  "note/getnote",
  "note/getnotebook",
  "note/getobjectnotes",
  "note/search",
  "notification/getnotifications",
  "org/getusergroupmodel",
  "org/getusergroups",
  "org/getuserinvitations",
  "photo/getallphotos",
  "photo/getchildlibraries",
  "photo/getlibraries",
  "photo/getmobilephoto",
  "photo/getphoto",
  "photo/getphotos",
  "posts/getmobilepost",
  "posts/getmobileposts",
  "posts/getmobilethoughts",
  "posts/getnewposts",
  "posts/getpostcontent",
  "posts/getposts",
  "posts/getpostsbyuser",
  "posts/getsavedpostids",
  "posts/getuserpostedphotoids",
  "profile/getfullprofile",
  "profile/getpublicattributes",
  "profile/getsitefullprofile",
  "project/getprojects",
  "project/getuserprojects",
  "reactions/getmyreactions",
  "sites/getdocumentcontent",
  "sites/getfamilysite",
  "sites/getphotocontent",
  "sites/getsite",
  "sites/getsitemanagement",
  "video/getlibraries",
  "webpage/getpageusertype"
]);
